const nl = {
  components: {
    searchProduct: "Zoek product",
    withoutBarCode: "zonder streepjescode",
    stillHereModal: {
      title: "Bent u er nog?",
      closingIn: "Zo niet, dan sluiten we af in <0>{{count}} seconden.</0>",
      nextCustomer: "Volgende klant",
      stillHere: "Ja, ik ben er nog",
    },
    receipt: {
      vat: "BTW",
      deposit: "Statiegeld",
      yourReceipt: "Uw bon",
      subtotal: "Subtotaal",
    },
  },
  startPage: {
    title: "Scan & Betaal",
    scanBarCode: "Scan de streepjescode of druk op start",
    version: "Versie: {{version}}",
    pickupTitle: "Afhaalmenu bestellen",
    pickupSubtitle: "Druk op start om een bestelling te plaatsen",
  },
  mainPage: {
    pageTitle: "Scan uw producten",
    pickupPageTitle: "Wat wilt u later afhalen?",
    checkout: "Betalen",
    productSearch: "Product zoeken",
    selectCategory: "Selecteer categorie",
    yourReceipt: "Uw bon",
    emptyReceiptText: "Scan uw producten en kortingsvouchers",
    emptyPickupReceiptText: "Selecteer de producten die u wilt afhalen",
    foundProducts: "Gevonden producten",
    typeProduct: "Typ product...",
    ageCheckModal: {
      title: "Bent u {{ age }} jaar of ouder?",
      message: "Wij verkopen alcoholische producten alleen als u ouder bent dan {{ age }} jaar.",
      confirmText: "Ja, ik ben {{ age }} jaar of ouder",
      cancelText: "Nee",
    },
    combiDeals: {
      title: "Profiteer van de combideal!",
      noPriceMessage: "Scan of kies één van de producten hieronder en bespaar!",
      message: "Scan of kies één van de snacks hieronder en betaal slechts {{ price }}!",
      deal: "Combideal",
    },
    invalidQrScan: {
      title: "Ongeldige QR-code",
      message:
        "De gescande QR-code is niet geldig, probeer het opnieuw of ga langs bij de receptie.",
    },
    ageCheckValid: "{{ age }}+ producten kunnen nu worden toegevoegd.",
    productNotFound: "Gescand artikel niet gevonden",
    productNotFoundDescription:
      "We herkennen het gescande artikel niet, probeer het opnieuw of ga langs bij de receptie.",
    vouchers: {
      doYouHave: "Heeft u een <0>kortingsvoucher?</0>",
      scanForDiscount: "Scan de voucher voor korting",
      notValidTitle: "Deze QR is niet geldig",
    },
    errors: {
      unknownErrorTitle: "Onbekend probleem opgetreden",
      unknownErrorDescription:
        "Er is een onbekend probleem opgetreden. Probeer het opnieuw en ga anders langs de receptie.",
      notFoundTitle: "Gescande voucher niet gevonden",
      notFoundDescription:
        "We herkennen de gescande voucher niet, probeer het opnieuw of ga langs bij de receptie.",
      addEligibleProductDescription: "Voeg een artikel toe waarvoor deze voucher geldig is",
    },
  },
  checkoutPage: {
    followTerminal: "Volg de betaling op de betaalterminal.",
  },
  verificationPage: {
    title: "Om te controleren of u {{ age }}+ bent, dient u een QR-code te scannen.",
    verifiedID:
      "Heeft u een geverifieerd RestaurantID (herkenbaar aan het gouden vinkje) in de Valk Exclusief app? Scan dan uw RestaurantID.",
    or: "OF",
    getCodeAtReception: "Haal een QR code bij de receptie.",
  },
  successPage: {
    paid: "Betaald!",
    digitalReceipt: "Digitale bon",
    review: "Beoordeling",
    tip: "Heeft u nog een tip?",
    selectStars: "Selecteer het aantal sterren",
    sendReview: "Versturen",
    thanks: "Bedankt voor de feedback!",
    scanQr: "Scan de QR-code of typ uw emailadres voor een PDF van uw bon.",
    sendReceipt: "Verstuur bon",
    fillInEmailForReceipt: "Wilt u de bon digital ontvangen? Vul hieronder uw e-mailadres in.",
    emailError: "Er is een fout opgetreden, probeer het opnieuw of ga langs de receptie.",
    emailSent: "Verzonden",
    hasSentReceipt: "De email is verzonden!",
  },
  errorScreen: {
    title: "Helaas, er is iets fout gegaan. Probeer het opnieuw!",
    subTitle: "Mocht het meerdere keren fout gaan, ga langs de receptie.",
    noInternetTitle: "Geen internetverbinding. Probeer het opnieuw!",
  },
  failedPayment: {
    title: "Betaling niet gelukt!",
    backToReceipt: "Terug naar bon",
    startOver: "Opnieuw beginnen",
  },
  pickup: {
    timeSlotPage: {
      title: "Kies uw afhaalmoment",
      otherOptions: "Andere mogelijkheden:",
      tomorrow: "Morgen",
    },
    yourInfoPage: {
      yourInfo: "Uw gegevens",
      personalInfo: "Persoonlijke gegevens",
      firstName: "Voornaam",
      lastName: "Achternaam",
      emailAddress: "E-mailadres",
      phoneNumber: "Telefoonnummer",
      emailDesc: "De digitale bon versturen wij naar dit e-mailadres",
      phoneNumberDesc: "Mochten er vragen zijn over uw bestelling",
      pay: "Afrekenen",
      chosenTimeSlot: "Uw gekozen afhaalmoment",
      errors: {
        firstName: "Vul uw voornaam in",
        lastName: "Vul uw achternaam in",
        phoneNumber: "Vul een geldig telefoonnummer in",
        emailAddress: "Vul een geldig e-mailadres in",
      },
    },
    successPage: {
      thanks: "Bedankt voor uw bestelling!",
      emailConfirmation: "We sturen de bevestiging en de bon naar <0>{{ email }}</0>",
    },
  },
  ui: {
    start: "Start",
    total: "Totaal",
    search: "Zoeken",
    cancel: "Annuleren",
    tryAgain: "Probeer opnieuw",
    yourEmail: "Uw emailadres",
    close: "Afsluiten",
    no: "Nee",
    closeModal: "Sluiten",
    back: "Terug",
    continue: "Doorgaan",
    from: "Vanaf",
  },
};

export default nl;
